export const GavelIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3227_154905)">
      <path
        d="M4.93988 9.31095C4.80055 9.17166 4.69003 9.00629 4.61463 8.82428C4.53923 8.64227 4.50042 8.44718 4.50042 8.25017C4.50042 8.05316 4.53923 7.85808 4.61463 7.67607C4.69003 7.49406 4.80055 7.32868 4.93988 7.18939L10.9399 1.18939C11.2212 0.908053 11.6028 0.75 12.0007 0.75C12.3985 0.75 12.7801 0.908053 13.0614 1.18939C13.3428 1.47073 13.5008 1.8523 13.5008 2.25017C13.5008 2.64804 13.3428 3.02962 13.0614 3.31095L7.06144 9.31095C6.92215 9.45028 6.75677 9.5608 6.57476 9.6362C6.39275 9.7116 6.19767 9.75041 6.00066 9.75041C5.80365 9.75041 5.60856 9.7116 5.42655 9.6362C5.24454 9.5608 5.07917 9.45028 4.93988 9.31095ZM22.8114 10.9394C22.6721 10.8001 22.5068 10.6895 22.3248 10.6141C22.1428 10.5387 21.9477 10.4999 21.7507 10.4999C21.5536 10.4999 21.3586 10.5387 21.1766 10.6141C20.9945 10.6895 20.8292 10.8001 20.6899 10.9394L14.6899 16.9394C14.4088 17.2207 14.2509 17.602 14.2509 17.9997C14.2509 18.3974 14.4088 18.7787 14.6899 19.06C14.8292 19.1993 14.9945 19.3099 15.1766 19.3853C15.3586 19.4607 15.5536 19.4995 15.7507 19.4995C15.9477 19.4995 16.1428 19.4607 16.3248 19.3853C16.5068 19.3099 16.6721 19.1993 16.8114 19.06L22.8114 13.06C23.0925 12.7787 23.2504 12.3974 23.2504 11.9997C23.2504 11.602 23.0925 11.2207 22.8114 10.9394ZM19.2808 9.22001L14.7808 4.72001C14.6402 4.57947 14.4495 4.50052 14.2507 4.50052C14.0518 4.50052 13.8611 4.57947 13.7205 4.72001L8.4705 9.97001C8.32996 10.1107 8.25101 10.3013 8.25101 10.5002C8.25101 10.699 8.32996 10.8897 8.4705 11.0303L9.65644 12.22L2.68988 19.1903C2.42045 19.4739 2.27246 19.8515 2.27747 20.2427C2.28247 20.6338 2.44008 21.0075 2.71668 21.2841C2.99329 21.5607 3.367 21.7184 3.75814 21.7234C4.14928 21.7284 4.52691 21.5804 4.8105 21.311L11.7808 14.3444L12.9705 15.5341C13.1111 15.6746 13.3018 15.7536 13.5007 15.7536C13.6995 15.7536 13.8902 15.6746 14.0308 15.5341L19.2808 10.2841C19.351 10.2144 19.4066 10.1315 19.4446 10.0402C19.4826 9.94886 19.5022 9.85094 19.5022 9.75205C19.5022 9.65315 19.4826 9.55523 19.4446 9.46392C19.4066 9.37261 19.351 9.28972 19.2808 9.22001Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3227_154905">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GavelIconOutline = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.55915 1.93304L4.55913 6.93306C4.31505 7.17714 4.31505 7.57286 4.55913 7.81694L5.80927 9.06708C6.05335 9.31116 6.44908 9.31116 6.69316 9.06708L11.6932 4.06707C11.9373 3.82299 11.9373 3.42726 11.6932 3.18318L10.443 1.93304C10.199 1.68896 9.80322 1.68896 9.55915 1.93304Z"
      stroke="#242E5F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4341 8.80804L11.4341 13.8081C11.1901 14.0521 11.1901 14.4479 11.4341 14.6919L12.6843 15.9421C12.9283 16.1862 13.3241 16.1862 13.5682 15.9421L18.5682 10.9421C18.8123 10.698 18.8123 10.3023 18.5682 10.0582L17.318 8.80804C17.074 8.56396 16.6782 8.56396 16.4341 8.80804Z"
      stroke="#242E5F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3799 4.37891L16.1205 9.11953"
      stroke="#242E5F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.00488 8.75391L11.7455 13.4945"
      stroke="#242E5F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3122 12.0625L4.76531 17.6094C4.51637 17.8575 4.17925 17.9967 3.82781 17.9967C3.47636 17.9967 3.13924 17.8575 2.89031 17.6094C2.64223 17.3604 2.50293 17.0233 2.50293 16.6719C2.50293 16.3204 2.64223 15.9833 2.89031 15.7344L8.43718 10.1875"
      stroke="#808080"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface Props {
  winning?: boolean;
  isOver: boolean;
}
export const AuctionBanner = ({ winning = false, isOver }: Props) => {
  if (winning) {
    return (
      <div className="flex w-full items-center justify-center gap-[0.8rem] self-stretch bg-[#E9F4E9] pb-[1.6rem] pt-[2.4rem]">
        <span
          className="flex gap-[0.8rem] font-medium leading-[2.2rem]
text-[#228B22]"
        >
          <GavelIcon />
          {isOver
            ? `Congratulations! You've won the auction!`
            : `You're in the lead!`}
        </span>
      </div>
    );
  }
  return (
    <div className="flex w-full items-center justify-center gap-[0.8rem] self-stretch bg-[#FFEDED] pb-[1.6rem] pt-[2.4rem]">
      <span className="flex gap-[0.8rem] font-medium leading-[2.2rem] text-[#FF4242]">
        <GavelIcon />
        {isOver
          ? `You didn't win the auction.`
          : `You've been outbid. Increase your bid now!`}
      </span>
    </div>
  );
};
